import CustomMonthEvent from './CustomMonthEvent';

export default CustomMonthEvent;
